import React from 'react'
import styled from 'styled-components'
import { Token } from 'vvs-sdk'
import { Flex, Heading, useMatchBreakpoints } from 'vvs-uikit'
import { TokenPairImage } from 'components/TokenImage'
import { MultiYieldTag } from 'components/Tags'

export interface ExpandableSectionProps {
  lpLabel?: string
  token: Token
  quoteToken: Token
  multiYieldLabel?: boolean
}

/* const Wrapper = styled(Flex)`
  svg {
    margin-right: 4px;
  }
  ` */

const Wrapper = styled.div<{ isDesktop: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr 4fr;
  grid-template-columns: ${({ isDesktop }) => (isDesktop ? '1fr 1fr 4fr' : '1.5fr 1fr 4fr')};
`

const CardHeading: React.FC<ExpandableSectionProps> = ({ lpLabel, token, quoteToken, multiYieldLabel }) => {
  const { isDesktop } = useMatchBreakpoints()
  return (
    <Wrapper isDesktop={isDesktop}>
      <TokenPairImage variant="inverted" primaryToken={token} secondaryToken={quoteToken} width={32} height={32} />
      {multiYieldLabel ? <MultiYieldTag mb="3px" /> : <Flex />}
      <Flex justifySelf="flex-end">
        <Heading mb="4px">{lpLabel.split(' ')[0]}</Heading>
      </Flex>
    </Wrapper>
  )
}

export default CardHeading
